import { isNullOrWhitespace } from "../../../framework/utils";
import { forEach } from "../../../framework/utils/collection";
import { IComponentSource, ComponentModel, compressComponentSource, MarkdownComponent, blockquotePattern } from "./core";
import { applyTextDecoration } from "./text-decoration";

export interface IBlockquoteComponentModel extends IComponentSource {
  paragraphs: string[];
}

class BlockquoteComponentModel extends ComponentModel implements IBlockquoteComponentModel {
  public paragraphs: string[] = [];
}


export const buildBlockquoteComponentModel = (source: IComponentSource) => {
  compressComponentSource(source, false);
  const bqComponent = new BlockquoteComponentModel(source);
  let currentParagraph: string | null = null;
  forEach(source.content, line => {
    const content = line.content.replace(blockquotePattern, '');
    if(isNullOrWhitespace(content)) {
      if(currentParagraph !== null) { bqComponent.paragraphs.push(currentParagraph); }
      currentParagraph = null;
    } else if(currentParagraph === null) {
      currentParagraph = content;
    } else {
      currentParagraph = `${currentParagraph}<br/>${content}`;
    }
  });
  if(currentParagraph !== null) { bqComponent.paragraphs.push(currentParagraph); }

  bqComponent.paragraphs = bqComponent.paragraphs.map(p => applyTextDecoration(MarkdownComponent.Blockquote, p));
  return bqComponent;
}